/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Confirmpasswordplaceholder2Inputs */

const zh_auth_confirmpasswordplaceholder2 = /** @type {(inputs: Auth_Confirmpasswordplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请再次输入密码`)
};

const en_auth_confirmpasswordplaceholder2 = /** @type {(inputs: Auth_Confirmpasswordplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm your password`)
};

const es_auth_confirmpasswordplaceholder2 = /** @type {(inputs: Auth_Confirmpasswordplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirma tu contraseña`)
};

/**
* | output |
* | --- |
* | "Confirm your password" |
*
* @param {Auth_Confirmpasswordplaceholder2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_confirmpasswordplaceholder2 = /** @type {((inputs?: Auth_Confirmpasswordplaceholder2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Confirmpasswordplaceholder2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_confirmpasswordplaceholder2(inputs)
	if (locale === "en") return en_auth_confirmpasswordplaceholder2(inputs)
	return es_auth_confirmpasswordplaceholder2(inputs)
});
export { auth_confirmpasswordplaceholder2 as "auth_confirmPasswordPlaceholder" }